module.exports = __webpack_public_path__ + "img/jorge-gleizer-byn.6712749b.jpg";